import localStorageManager from "./localStorageManager";

const getCurrentUserId = () => {
    const userId = localStorageManager.getItem("userId");
    return userId !== null ? Number(userId) : null;
};

export default getCurrentUserId;
